<app-information-popup [page]="InformationPopupPage.ExtendedParameters"></app-information-popup>

<ng-container *ngIf="isActiveSessionAvailable">
  <div class="extended-parameters-content">
    <vi-loader
      *ngIf="remoteDiagnosticsUseCasesStore.loading$ | async; else showData"
      [isLoading]="true"
    ></vi-loader>

    <ng-template #showData>
      <app-extended-parameters-tabs></app-extended-parameters-tabs>
      <app-diagnostics-management-tab
        *ngIf="
          (remoteDiagnosticsStore.isParameterListEmpty(gatewaySerial) | async) ||
          !!(vddDetailsList$ | async)?.vddDetailsList.length
        "
      ></app-diagnostics-management-tab>
      <div
        *ngIf="selectedExtendedParametersTab$ | async as selectedExtendedParametersTab"
        class="flex flex-col gap-[24px]"
      >
        <app-extended-parameter-welcome-screen
          [useCasesSelected]="selectedExtendedParametersTab === extendedParametersTabsEnum.UseCases"
          *ngIf="isParameterListEmpty || !(vddDetailsList$ | async)?.vddDetailsList.length"
        ></app-extended-parameter-welcome-screen>

        <app-diagnostics-parameters></app-diagnostics-parameters>
      </div>
    </ng-template>
  </div>
</ng-container>
